<template>
  <v-dialog
      v-model="dialog"
      class="column-manager"
      max-width="800px"
      persistent
  >
    <v-card>
      <v-toolbar flat>
        <b>Selective Export</b>
        <v-spacer></v-spacer>
        <v-text-field
            v-model="search"
            label="Search fields..."
            append-icon="search"
            dense
            hide-details
        ></v-text-field>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text style="height: 400px;">
        <fields-selector
            ref="fieldsSelector"
            :all-fields="allFields"
            :search="search"
            :show-historical-fields="false"
            :group-by="groupBy"
            :locked="[
              defaultExportFields.FIRSTNAME,
              defaultExportFields.LASTNAME,
              defaultExportFields.DATE_OF_BIRTH,
              defaultExportFields.SEQUENCE_NUMBER,
              defaultExportFields.INCIDENT_DATE,
            ]"
            v-bind:selected.sync="selected"
        />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer />
        <v-btn
            text
            @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
            :loading="exporting"
            text
            color="primary"
            @click="$emit('export', selected)"
        >
          Export
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import FIELDS_GROUP_BY from '@/enums/fieldsGroupBy';
import FieldsSelector from '@/components/Incidents/FieldsSelector';
import INCIDENT_EXPORT_FIELDS from '@/enums/incidentExportFields';

export default {
  components: { FieldsSelector },
  props: {
    allFields: {
      type: Array,
      required: true,
    },
    exporting: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      search: null,
      groupBy: FIELDS_GROUP_BY.VALUES,
      selected: [],
      defaultExportFields: INCIDENT_EXPORT_FIELDS,
    };
  },

  watch: {
    dialog(visible) {
      if (visible) {
        this.selected = [];
        this.search = null;
      }
    },
  },

  methods: {
    show() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
